import { createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { useMessageMention } from '../../../state/mentions/useMentions'
import { useChannel } from './useChannel'

export function useUi() {
	const { activeChannelResource } = useService(useChannel)()
	const { messageMentionChannelMap } = useService(useMessageMention)()
	const [isMentionOpen, setIsMentionOpen] = createSignal(false)
	const [isExpanded, setIsExpanded] = createSignal<boolean | undefined>()
	const [notAtBottom, setNotAtBottom] = createSignal<boolean>()
	const [ready, setReady] = createSignal<boolean>()

	const toggleIsExpanded = () => setIsExpanded(!isExpanded())

	const channelPathRoot = () => {
		return activeChannelResource()?.name === 'general'
			? '/chat'
			: `/chat/${activeChannelResource()?.name}`
	}

	const channelMessageMentions = () => {
		return activeChannelResource()?.id
			? messageMentionChannelMap()[activeChannelResource()!.id]
			: []
	}

	return {
		isExpanded,
		setIsExpanded,
		toggleIsExpanded,
		setNotAtBottom,
		notAtBottom,
		isMentionOpen,
		setIsMentionOpen,
		channelPathRoot,
		channelMessageMentions,
		ready,
		setReady,
	}
}
